import { render, staticRenderFns } from "./RoleAdd.vue?vue&type=template&id=c2dd53ae&scoped=true"
import script from "./RoleAdd.vue?vue&type=script&lang=js"
export * from "./RoleAdd.vue?vue&type=script&lang=js"
import style0 from "./RoleAdd.vue?vue&type=style&index=0&id=c2dd53ae&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dd53ae",
  null
  
)

export default component.exports